<template>
  <div class="healthyCommunity pb-5 ctm-container">
    <h1 class="healthy-community-title my-3">{{$t('healthyCommunityTitle')}}</h1>
    <b-row class="d-flex justify-content-center">
      <healthy-community-vertical-card v-for="item in cards" :key="item.title" :path="item.path" :soonLabel="item.soonLabel" :sectionId="item.sectionId" :img="item.img" :title="item.title" :description="item.description" :onlySubscribers="item.onlySubscribers"></healthy-community-vertical-card>
    </b-row>
  </div>
</template>

<script>
import BackBtn from '@/components/base/buttons/BackButton'
import forumMixin from '@/mixins/forum.mixin'
import HealthyCommunityVerticalCard from '@/components/views/healthy-community/HealthyCommunityVerticalCard'
import { FORUM_HEALTH_COMMUNITY_SECTION, WHO_IN_HEALTH_COMMUNITY_SECTION } from '@/constants/healthyCommunitySections'

export default {
  name: 'healthy-community',
  mixins: [forumMixin],
  components: {
    HealthyCommunityVerticalCard,
    BackBtn
  },
  data () {
    return {
      cardsSource: [
        {
          title: this.$t('whoIn'),
          img: '/static-appopensalud/img/healthy-community/who-in-simplified.svg',
          description: `${this.$t('whoInSectionDescription')}`,
          path: 'quienseapunta',
          sectionId: WHO_IN_HEALTH_COMMUNITY_SECTION,
          onlySubscribers: true
        },
        /* {
          title: this.$t('healthyInformation'),
          img: '/static-appopensalud/img/healthy-community/healthy-information.svg',
          description: `${this.$t('healthyInformationSectionDescription')}`,
          path: 'informacionsalud',
          sectionId: HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION
        }, */
        {
          title: this.$t('patientsLikeYou'),
          img: '/static-appopensalud/img/healthy-community/patients-like-you.svg',
          description: this.$t('forumSectionDescription'),
          path: 'pacientescomotu',
          sectionId: FORUM_HEALTH_COMMUNITY_SECTION
        }
      ]
    }
  },
  created () {
    this.$store.state.forum.hideSearcher = true
    this.$store.state.forum.entriesPageNumber = 0
  },
  computed: {
    cards () {
      return this.cardsSource
    }
  }
}
</script>

<style lang="scss">
  .healthyCommunity {
    min-height: 70dvh;
  }
  .healthy-community-title{
    text-align: center;
  }
  .btn-go-openhealth{
    display: block;
    margin-left: 5rem;
    @include media(mobile, tablets) {
      margin-left: 1rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/HealthyCommunity.vue